import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=194aa5ef&"
import script from "./Accordion.js?vue&type=script&lang=js&"
export * from "./Accordion.js?vue&type=script&lang=js&"
import style0 from "./Accordion.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports